import { createHrefs, createUtm } from "@indietabletop/appkit";

export const hrefs = createHrefs({
  utm: createUtm({
    source: "indietabletopclub",
    medium: "referral",
    campaign: "greathelm_app",
  }),

  hrefs: {
    account: () => `~/settings`,
  },
});
